// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TLhj","col":"styles_col__30G_q"};